'use strict';

var utils = require('../utils');

function apply() {
  if (global.navigator && global.navigator.geolocation) {
    utils.patchPrototype(global.navigator.geolocation, [
      'getCurrentPosition',
      'watchPosition'
    ]);
  }
}

module.exports = {
  apply: apply
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/zone.js/lib/patch/geolocation.js
 ** module id = 515
 ** module chunks = 1
 **/